import {
  BUSCAR_MAPA_ITINERARIO_VOLTA,
  LIMPAR_MAPA_ITINERARIO_VOLTA,
  SELECIONAR_ASSENTO_ITINERARIO_VOLTA,
  BLOQUEAR_POLTRONA_JA_MARCADO_ITINEARARIO_VOLTA
} from '../../actions/types'

const initialState = undefined
const itemInicial = { nome: '', uf: null }

export default function reducerMapaVeiculoItinerarioVolta (state = itemInicial, action = initialState) {
  switch (action.type) {
    case BUSCAR_MAPA_ITINERARIO_VOLTA: {
      return action.payload.data;
    }

    case SELECIONAR_ASSENTO_ITINERARIO_VOLTA: {
      const { assento, fileira } = action.payload;
      const indiceFileira = state.indexOf(state.filter(f => f.id === fileira.id)[0]);
      const novo = [...state];
      const novaFileira = Object.assign({}, fileira);
      const novosAssentos = [...novaFileira.assentos]
      const indiceAssento = novaFileira.assentos.indexOf(assento);
      const novoAssento = Object.assign({}, assento, { selecionado: !assento.selecionado });
      novosAssentos[indiceAssento] = novoAssento;
      novaFileira.assentos = novosAssentos;
      novo[indiceFileira] = novaFileira;

      return novo
    }
    case BLOQUEAR_POLTRONA_JA_MARCADO_ITINEARARIO_VOLTA: {
      const { assento, fileira } = action.payload;
      const indiceFileira = state.indexOf(state.filter(f => f.id === fileira.id)[0]);
      const novo = [...state];
      const novaFileira = Object.assign({}, fileira);
      const novosAssentos = [...novaFileira.assentos]
      const indiceAssento = novaFileira.assentos.indexOf(assento);
      const novoAssento = Object.assign({}, assento, { selecionado: true, ehBloqueado: true });
      novosAssentos[indiceAssento] = novoAssento;
      novaFileira.assentos = novosAssentos;
      novo[indiceFileira] = novaFileira;

      return novo
    }
    case LIMPAR_MAPA_ITINERARIO_VOLTA: {
      return itemInicial
    }

    default: {
      return state
    }
  }
}
